import React from 'react';
import { Input, DatePicker, Select as AntSelect } from 'antd';
import styles from './floatingLabelInput.module.scss';
import Select from "../select/Select";

export const FloatingLabelInput = ({
       label,
       value,
       placeholder,
       disabled,
       type = "text",
       ...props
   }) => {
    const hasValue = value !== undefined && value !== null && value !== '';

    return (
        <div className={`${styles.floatingLabel} ${hasValue ? styles.hasValue : ''} ${disabled ? styles.disabled : ''}`}>
            <Input
                value={value}
                disabled={disabled}
                placeholder={placeholder}
                type={type}
                {...props}
            />
            <label className={styles.label}>{label}</label>
        </div>
    );
};

export const FloatingLabelTextArea = ({
      label,
      value,
      placeholder,
      disabled,
      rows = 4,
      ...props
  }) => {
    const hasValue = value !== undefined && value !== null && value !== '';

    return (
        <div className={`${styles.floatingLabel} ${hasValue ? styles.hasValue : ''} ${disabled ? styles.disabled : ''}`}>
            <Input.TextArea
                value={value}
                disabled={disabled}
                placeholder={placeholder}
                rows={rows}
                {...props}
            />
            <label className={styles.label}>{label}</label>
        </div>
    );
};

export const FloatingLabelSelect = ({
        label,
        value,
        placeholder,
        disabled,
        items,
        onChange,
        ...props
    }) => {
    const hasValue = value !== undefined && value !== null && value !== '';
    const selectedOption = items?.find(opt => opt.value === value);

    return (
        <div className={`${styles.floatingLabel} ${hasValue ? styles.hasValue : ''} ${disabled ? styles.disabled : ''}`}>
            <Select
                label=""
                value={selectedOption} 
                items={items}
                onChange={(selectedValue, selectedLabel) => {
                    onChange(selectedValue);
                }}
                placeholder={placeholder}
                disabled={disabled}
                className={styles.selectInside}
                {...props}
            />
            <label className={styles.label}>{label}</label>
        </div>
    );
};

export const FloatingLabelSearchSelect = ({
  label,
  value,
  placeholder,
  disabled,
  options = [],
  onChange,
  onSearch,
  loading,
  notFoundContent = 'Nema rezultata',
  mode,
  ...props
}) => {
  // In multiple/tags mode the value is an array — an empty one means no value, and the box
  // needs the multiSelect variant so it grows with its pills instead of the fixed 56px height
  // pushing them outside the field.
  const isMulti = mode === 'multiple' || mode === 'tags';
  const hasValue = isMulti
    ? Array.isArray(value) && value.length > 0
    : value !== undefined && value !== null && value !== '';

  return (
    <div
      className={`${styles.floatingLabel} ${isMulti ? styles.multiSelect : ''} ${hasValue ? styles.hasValue : ''} ${disabled ? styles.disabled : ''}`}
    >
      <AntSelect
        mode={mode}
        showSearch
        value={value || undefined}
        placeholder={placeholder}
        disabled={disabled}
        onChange={onChange}
        onSearch={onSearch}
        filterOption={false}
        loading={loading}
        notFoundContent={notFoundContent}
        options={options}
        style={{ width: '100%' }}
        {...props}
      />
      <label className={styles.label}>{label}</label>
    </div>
  );
};

export const FloatingLabelDatePicker = ({
        label,
        value,
        placeholder,
        disabled,
        ...props
    }) => {
    const hasValue = value !== undefined && value !== null;

    return (
        <div className={`${styles.floatingLabel} ${hasValue ? styles.hasValue : ''} ${disabled ? styles.disabled : ''}`}>
            <DatePicker
                value={value}
                disabled={disabled}
                placeholder={placeholder}
                style={{ width: '100%' }}
                {...props}
            />
            <label className={styles.label}>{label}</label>
        </div>
    );
};